import Button from '../Button';

function OfferCard(props: {
  title: string;
  desc: string;
  imageUrl: string;
  id: number;
}) {
  return (
    <div
      className="h-full flex flex-col justify-between gap-4 w-[380px] xl:w-[440px]"
      key={props.id}
    >
      <div className="flex flex-col gap-4">
        <img
          src={props.imageUrl}
          className="w-full"
          alt="offer image"
          loading="lazy"
        />
        <div className="flex flex-col gap-2 min-h-[180px]">
          <div className="text-[25px] font-bold text-defaultDark">
            {props.title}
          </div>
          <div className="text-defaultDark max-w-[80%]">{props.desc}</div>
        </div>
      </div>
      <Button
        label="Sprawdź"
        onClick={() => window.location.assign('/offer/' + props.id)}
      />
    </div>
  );
}

export default OfferCard;
